module.exports = function () {
    return String(new Date().getFullYear())
}
